export default {
  GET_PERSON_QUERY_SERVICE: Symbol.for('GET_PERSON_QUERY_SERVICE'),
  SEARCH_PERSON_REPOSITORY: Symbol.for('SEARCH_PERSON_REPOSITORY'),
  ONBOARDING_PERSON_STATE_MANAGER: Symbol.for('ONBOARDING_PERSON_STATE_MANAGER'),
  ONBOARDING_UPDATE_PERSON_REPOSITORY: Symbol.for('ONBOARDING_UPDATE_PERSON_REPOSITORY'),
  ONBOARDING_UPDATE_PERSON_COMMAND: Symbol.for('ONBOARDING_UPDATE_PERSON_COMMAND'),
};
